// extracted by mini-css-extract-plugin
export default {"brandPromo":"UF-z","carousel":"VF-z"};